import logoWu from '@assets/logo-wu-dark.svg';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useGlobalDIContext } from '@context/GlobalDIContext';

function WuErrorFallback() {
  const { TranslationAdapter } = useGlobalDIContext();
  const { t } = TranslationAdapter();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '96vh',
        flexDirection: 'column',
      }}
    >
      <Box component="img" src={logoWu} width="250" alt="Wester union logo" sx={{ width: 400 }} />
      <Typography sx={{ fontWeight: 600, fontSize: 18 }}>{t('applicationError')}</Typography>
    </Box>
  );
}

export default WuErrorFallback;
